<template>
  <v-card class="mt-3 rounded-card">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline font-weight-bold">
          Detalhamento de preço
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-data-table
        show-expand
        hide-default-footer
        disable-pagination
        item-key="id"
        class="elevation-0"
        :loading="loadingItensCarrinho"
        loading-text="Carregando itens...."
        :headers="headers"
        :items="resposta.produtos"
        :expanded.sync="expanded"
      >
        <template v-slot:header.options>
          <div class="d-flex justify-end">
            <v-tooltip top v-if="showCarrinhoProp && hasRoleComprador">
              <template v-slot:activator="{ on }">
                <v-btn icon
                      v-on="on"
                      @click="adicionarTodos()"
                      :disabled="!resposta.produtos">
                  <v-icon>mdi-cart-variant</v-icon>
                </v-btn>
              </template>
              <span>Adicionar todos os produtos ao carrinho</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" v-if="isMoedaEstrangeira">
              <px-moeda-chip :moeda="moeda"/>
            </v-col>
            <v-col cols="12" sm="4">
              <template v-if="isMoedaEstrangeira">
                <v-row dense no-gutters class="body-1">
                  <v-col cols="6">
                    Produtos:
                  </v-col>
                  <v-col cols="6" class="text-right">
                    {{
                      resposta.totalProdutos |
                        currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                    }}
                  </v-col>
                  <v-col cols="6">
                    Frete:
                  </v-col>
                  <v-col cols="6" class="text-right">
                    {{
                      resposta.frete.totalTransporte |
                        currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                    }}
                  </v-col>
                  <v-col cols="6" class="font-weight-bold">
                    Total:
                  </v-col>
                  <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{
                      resposta.total |
                        currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                    }}
                  </span>
                  </v-col>
                  <template v-if="isMoedaEstrangeira && resposta.saving">
                    <v-col cols="6" class="font-weight-bold">
                      Saving:
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{
                          resposta.saving |
                            currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                        }}
                      </span>
                    </v-col>
                  </template>
                </v-row>
              </template>
            </v-col>
            <v-col cols="12" sm="4"></v-col>
            <v-col cols="12" sm="4">
              <v-row dense no-gutters class="body-1">
                <v-col cols="6">
                  Produtos:
                </v-col>
                <v-col cols="6" class="text-right">
                  {{ resposta.valorMoedaConvertido.totalProdutos | currency('R$', casaDecimal) }}
                </v-col>
                <v-col cols="6">
                  Frete:
                </v-col>
                <v-col cols="6" class="text-right">
                  {{ resposta.frete.totalTransporteConvertido | currency }}
                </v-col>
                <v-col cols="6" class="font-weight-bold">
                  Total:
                </v-col>
                <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{ resposta.valorMoedaConvertido.total | currency('R$', casaDecimal) }}
                  </span>
                </v-col>
                <template v-if="resposta.saving">
                  <v-col cols="6" class="font-weight-bold">
                    Saving:
                  </v-col>
                  <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{ resposta.valorMoedaConvertido.saving | currency }}
                      </span>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.descricao="{ item }">
          <span>
            <px-produto-descricao :tooltip-truncate-chars="25"
                                  :especificacao="item.cotacaoProduto.especificacaoProduto"
                                  :produto="item.cotacaoProduto.produto"/>&nbsp;
            <px-historico-preco-produto small
                                        :produto="item.cotacaoProduto.produto"
                                        :unidade-medida="item.cotacaoProduto.unidadeMedida"/>
            <px-show-is-homologado small
                                   :produto="item.cotacaoProduto.produto"
                                   :id-fornecedor="resposta.fornecedor.id"/>
          </span>
        </template>
        <template v-slot:item.quantidade="{ item }">
          <span>
            {{
              item.cotacaoProduto.quantidade
                | number(getCurrencyFormat(item.cotacaoProduto.produto.casasDecimais))
            }}&nbsp;
          {{ item.cotacaoProduto.unidadeMedida.descricao }}
          </span>
        </template>
        <template v-slot:item.precoUnitario="{ item }">
          <div v-if="isRespondida(item)">
            {{
              item.valorMoedaConvertido.precoUnitario
                | currency('R$', item.cotacaoProduto.produto.casasDecimais)
            }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                item.precoUnitario
                  | currency(simboloMoeda,
                  item.cotacaoProduto.produto.casasDecimais,
                  configuracaoFormatacaoMoeda)
              }}
            </div>
          </div>
        </template>
        <template v-slot:item.icms="{ item }">
          <template v-if="isRespondida(item)">
            <px-imposto show-valor-convertido
                        :imposto="item.impostos"
                        tipo="ICMS"
                        :scale="item.cotacaoProduto.produto.casasDecimais"/>
            <div v-if="isMoedaEstrangeira">
              <px-imposto class="caption"
                          :imposto="item.impostos"
                          :simbolo-moeda="simboloMoeda"
                          :configuracao-moeda="configuracaoFormatacaoMoeda"
                          tipo="ICMS"
                          :scale="item.cotacaoProduto.produto.casasDecimais"/>
            </div>
          </template>
        </template>
        <template v-slot:item.ipi="{ item }">
          <template v-if="isRespondida(item)">
            <px-imposto show-valor-convertido
                        :imposto="item.impostos"
                        tipo="IPI"
                        :scale="item.cotacaoProduto.produto.casasDecimais"/>
            <div v-if="isMoedaEstrangeira">
              <px-imposto class="caption"
                          :imposto="item.impostos"
                          :simbolo-moeda="simboloMoeda"
                          :configuracao-moeda="configuracaoFormatacaoMoeda"
                          tipo="IPI"
                          :scale="item.cotacaoProduto.produto.casasDecimais"/>
            </div>
          </template>
        </template>
        <template v-slot:item.total="{ item }">
          <div v-if="isRespondida(item)">
            {{
              item.valorMoedaConvertido.total |
                currency('R$', item.cotacaoProduto.produto.casasDecimais)
            }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                item.total
                  | currency(simboloMoeda,
                  item.cotacaoProduto.produto.casasDecimais,
                  configuracaoFormatacaoMoeda)
              }}
            </div>
          </div>
        </template>
        <template v-slot:item.options="{ item }" v-if="hasRoleComprador">
          <px-situacao-cotacao-produto :situacao="item.situacao"/>
          <template v-if="isAdicionavelCarrinho(item) && !item.$adicionado">
            <div class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon
                         v-on="on"
                         @click="adicionar(item)">
                    <v-icon>mdi-cart</v-icon>
                  </v-btn>
                </template>
                <span>Adicionar item ao carrinho</span>
              </v-tooltip>
            </div>
          </template>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="grey lighten-4 expanded-item">
            <v-row dense class="mt-3">
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Especificação solicitada</span>
                <div>
                  <px-show-large-text :large-text="item.cotacaoProduto.especificacaoProduto"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Especificação do fornecedor</span>
                <div>
                  <px-show-large-text :large-text="item.especificacaoProduto"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Arquivos</span>
                <div v-if="item.arquivos.length">
                  <px-anexo-chip :files="item.arquivos"
                                 download-base-path="files/download-fornecedor"/>
                </div>
                <div v-else>
                  Nenhum anexo informado
                </div>
              </v-col>
            </v-row>
            <v-row dense class="mt-3">
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Observações Externas do Produto</span>
                <div>
                  <px-show-large-text :large-text="observacaoExterna(item.cotacaoProduto)"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Observações Internas do Produto</span>
                <div>
                  <px-show-large-text :large-text="observacaoInterna(item.cotacaoProduto)"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Código de referência do fornecedor</span>
                <div>
                  {{ codigoReferencia(item.cotacaoProduto.produto.fornecedoresProduto)
                  | naoInformado }}
                </div>
              </v-col>
            </v-row>
            <v-row dense class="mt-3">
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Finalidade da compra</span>
                <div v-if="item.cotacaoProduto.finalidadeCompra">
                  <px-finalidade-compra-value
                    :finalidade-compra="item.cotacaoProduto.finalidadeCompra"/>
                </div>
                <div v-else>
                  Não informado
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Prazo de entrega</span>
                <div>
                  {{ item.cotacaoProduto.dataPrevisaoEntrega | date | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.impostos.valorDifalConvertido">
                <span class="caption font-weight-bold">Valor total DIFAL</span>
                <div>
                  {{ item.impostos.valorDifalConvertido
                   | currency('R$', casaDecimal) }}
                </div>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { SituacaoRespostaCotacaoProduto, SituacaoCotacao } from 'px-business-components';
import { CasaDecimalUtils, FornecedorProdutoUtils } from 'px-components';
import { ADD_ITEM, GET_ITENS } from '@/store/carrinho/actions.type';
import CarrinhoService from '@/modules/carrinho/carrinho-service';
import Vue from 'vue';
import moedaMixin from '@/mixins/moeda-mixin';
import { isFornecedorHomologado, filterProdutoNaoHomologado } from '@/utils/fornecedor-produto-utils';

export default {
  mixins: [moedaMixin],
  props: {
    resposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showCarrinhoProp: false,
      loadingItensCarrinho: false,
      expanded: [],
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Preço unitário',
          value: 'precoUnitario',
        },
        {
          text: 'ICMS',
          value: 'icms',
          sortable: false,
        },
        {
          text: 'IPI',
          value: 'ipi',
          sortable: false,
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: '',
          value: 'options',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    moeda() {
      return this.resposta.moeda;
    },
    isRespondida() {
      return item => item.situacao
        === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    isAberta() {
      return item => item.cotacaoProduto.situacao === SituacaoCotacao.keys.ABERTA.key;
    },
    isAdicionavelCarrinho() {
      return item => this.isAberta(item) && this.isRespondida(item);
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casaDecimal() {
      const mappedProdutos = this.resposta.produtos.map(produto => produto.cotacaoProduto.produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
    observacaoInterna() {
      return (produto) => {
        if (produto.observacaoInterna) {
          return produto.observacaoInterna;
        }
        return produto.produto.observacaoInterna;
      };
    },
    observacaoExterna() {
      return (produto) => {
        if (produto.observacaoExterna) {
          return produto.observacaoExterna;
        }
        return produto.produto.observacaoExterna;
      };
    },
    codigoReferencia() {
      return fornecedoresProduto => FornecedorProdutoUtils.getCodigoReferenciaFornecedor(
        fornecedoresProduto,
        this.resposta.fornecedor.id,
      );
    },
  },
  methods: {
    ...mapActions('carrinho', {
      addItem: ADD_ITEM,
      getItens: GET_ITENS,
    }),
    isFornecedorHomologadoAoProduto(produto) {
      const { fornecedoresProduto } = produto.cotacaoProduto.produto;
      if (isEmpty(fornecedoresProduto)
        || isEmpty(fornecedoresProduto.filter(fp => fp.homologado))) {
        return true;
      }
      return isFornecedorHomologado(fornecedoresProduto, this.resposta.fornecedor.id);
    },
    adicionar(item) {
      if (!this.isFornecedorHomologadoAoProduto(item)) {
        this.$toast(`Este fornecedor não é homologado para o produto: ${item.cotacaoProduto.produto.descricao}`, { color: 'error' });
        return;
      }
      this.addItem(item.id)
        .then(() => {
          Vue.set(item, '$adicionado', true);
          this.$toast('Item adicionado ao carrinho', { color: 'success' });
          this.$emit('updated');
        });
    },
    getProdutosNaoHomologados() {
      return this.resposta.produtos
        .map(p => p.cotacaoProduto.produto)
        .filter(p => filterProdutoNaoHomologado(p, this.resposta.fornecedor.id));
    },
    adicionarTodos() {
      const ids = this.resposta.produtos
        .filter(p => this.isAdicionavelCarrinho(p) && this.isFornecedorHomologadoAoProduto(p))
        .map(p => p.id);
      if (ids.length === 0) {
        const produtos = this.getProdutosNaoHomologados();
        const errorMessage = produtos.length > 1 ? `Este fornecedor não é homologado para os produtos: ${produtos.map(p => p.descricao).join(', ')}` : `Este fornecedor não é homologado para o produto: ${produtos[0].descricao.trim()}`;
        this.$toast(errorMessage, { color: 'error' });
        return;
      }
      CarrinhoService.adicionarTodosProdutos(ids)
        .then(() => {
          this.resposta.produtos.forEach(p => Vue.set(p, '$adicionado', true));
          this.$toast('Itens adicionados ao carrinho', { color: 'success' });
          this.$emit('updated');
          this.getItens();
        });
    },
    filterProdutosAdicionaveis(produtosNoCarrinhoIds) {
      return this.resposta.produtos
        .filter(p => this.isAdicionavelCarrinho(p) && !produtosNoCarrinhoIds.includes(p.id));
    },
    showCarrinho(produtosNoCarrinhoIds) {
      const produtosAdicionaveis = this.filterProdutosAdicionaveis(produtosNoCarrinhoIds);
      return produtosNoCarrinhoIds.length < produtosAdicionaveis.length;
    },
    mapProdutosNoCarrinhoIds(carrinhos) {
      return carrinhos.forEach(carrinho => carrinho.produtos.map(p => p.respostaCotacaoProduto.id));
    },
    checkShowCarrinho() {
      this.loadingItensCarrinho = true;
      CarrinhoService.getItensCarrinho()
        .then((response) => {
          const carrinhos = response.data;
          const produtosNoCarrinhoIds = this.mapProdutosNoCarrinhoIds(carrinhos) || [];
          this.showCarrinhoProp = this.showCarrinho(produtosNoCarrinhoIds);
        })
        .finally(() => {
          this.loadingItensCarrinho = false;
        });
    },
  },
  created() {
    const [firstItem] = this.resposta.produtos;
    this.expanded = [firstItem];
    this.checkShowCarrinho();
  },
};
</script>

<style scoped>
.expanded-item {
  box-shadow: inset 0 4px 4px -5px rgba(50, 50, 50, 0.75),
  inset 0 -4px 4px -5px rgba(50, 50, 50, 0.75);
}
</style>
